import type { TrackState } from '../api.js';

const COLOR: Record<TrackState, 'gray' | 'yellow' | 'green' | 'red'> = {
  DRAFTING_SPEC: 'gray',
  SPEC_REVIEW: 'yellow',
  AWAITING_PREREQS: 'yellow',
  QUEUED: 'gray',
  BUILDING: 'gray',
  VERIFYING: 'gray',
  PR_OPEN: 'yellow',
  MERGED: 'green',
  DONE: 'green',
  BLOCKED_HUMAN: 'yellow',
  FAILED_BUILD: 'red',
  FAILED_SCOPE: 'red',
  CANCELLED: 'gray',
};

export default function StateBadge({ state }: { state: TrackState }) {
  const color = COLOR[state] ?? 'gray';
  return <span className={`badge badge-${color}`}>{state}</span>;
}
